/* Oz BBQ homepage (AAA). Quick add for the shared product card
   (snippets/aaa-product-card.liquid, [data-aaa-pcard-add]) on the homepage,
   where the collection script isn't loaded. Posts to /cart/add.js; the
   header's live cart count (aaa-base.js) picks the call up on its own.
   Falls back to a normal form post on any failure. */
(function () {
  'use strict';
  var doc = document;
  if (!doc.body || doc.body.getAttribute('data-aaa-tpl') !== 'index') return;
  if (window.__aaaHomePcard) return;
  window.__aaaHomePcard = true;

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-aaa-pcard-add]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = form.querySelector('[data-label]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var original = label ? label.textContent : '';
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-busy');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        doc.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 2600);
      })
      .catch(function () { form.submit(); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();

/* Cooker finder (snippets/aaa-home-finder.liquid). Three radio groups ->
   one pre-rendered result card. Pure show/hide: every price and title in
   the cards is live Liquid. The panel is never empty: unanswered questions
   take the defaults (wood / walk / 6-10 -> GMG Ledge, pre-checked in the
   markup), so the pick updates on every tap. If the first-choice card wasn't rendered (sold out /
   missing), the next one in its list is shown. */
(function () {
  'use strict';
  var root = document.querySelector('[data-aaa-finder]');
  if (!root) return;
  root.classList.add('is-js');
  var form = root.querySelector('[data-aaa-finder-form]');
  var basis = root.querySelector('[data-aaa-finder-basis]');
  var cards = root.querySelectorAll('[data-aaa-finder-res]');
  var DEF = { taste: 'wood', effort: 'walk', crowd: 'm' };
  var WORDS = {
    taste: { char: 'charcoal', wood: 'wood smoke', both: 'charcoal and wood' },
    effort: { tend: 'you tend the fire', walk: 'set and walk off' },
    crowd: { s: 'feeding 2–4', m: 'feeding 6–10', l: 'feeding 12+' }
  };
  // taste-effort-crowd -> ordered preferences
  var MAP = {
    'char-tend-s': ['jr', 'classic'], 'char-tend-m': ['classic', 'big'], 'char-tend-l': ['big', 'classic'],
    'char-walk-s': ['g600', 'g800'], 'char-walk-m': ['g600', 'g800'], 'char-walk-l': ['g800', 'g600'],
    'wood-tend-s': ['classic', 'offset'], 'wood-tend-m': ['offset', 'classic'], 'wood-tend-l': ['offset', 'big'],
    'wood-walk-s': ['br4', 'br6', 'gmg'], 'wood-walk-m': ['gmg', 'br6'], 'wood-walk-l': ['br6', 'gmg'],
    'both-tend-s': ['jr', 'classic'], 'both-tend-m': ['classic', 'big'], 'both-tend-l': ['big', 'classic'],
    'both-walk-s': ['g600', 'g800'], 'both-walk-m': ['g800', 'g600'], 'both-walk-l': ['g800', 'g600']
  };
  function val(n) { var el = form.querySelector('input[name="' + n + '"]:checked'); return el ? el.value : ''; }
  function show(id) {
    var shown = null;
    for (var i = 0; i < cards.length; i++) {
      var on = cards[i].getAttribute('data-aaa-finder-res') === id;
      cards[i].hidden = !on;
      if (on) shown = cards[i];
    }
    return shown;
  }
  // Nothing is pre-checked (r8). "touched" = groups the shopper
  // has changed by hand; the progress segments read muted for defaults and
  // solid for touched answers.
  var touched = {};
  var dots = root.querySelectorAll('.aaa-finder__dots [data-q]');
  function update(fromUser) {
    var a = { taste: val('taste'), effort: val('effort'), crowd: val('crowd') };
    var answered = (touched.taste ? 1 : 0) + (touched.effort ? 1 : 0) + (touched.crowd ? 1 : 0);
    root.setAttribute('data-answered', answered);
    for (var d = 0; d < dots.length; d++) {
      var q = dots[d].getAttribute('data-q');
      dots[d].classList.toggle('is-set', !!touched[q]);
      dots[d].classList.toggle('is-def', !touched[q] && !!a[q]);
    }
    var t = a.taste || DEF.taste, e = a.effort || DEF.effort, c = a.crowd || DEF.crowd;
    var prefs = MAP[t + '-' + e + '-' + c] || ['gmg', 'classic'];
    var card = null;
    for (var i = 0; i < prefs.length && !card; i++) card = show(prefs[i]);
    if (!card) card = show('gmg') || show('classic');
    var label = answered === 0 ? 'Start here' : 'Your match';
    var labels = root.querySelectorAll('[data-aaa-finder-label]');
    for (var j = 0; j < labels.length; j++) labels[j].textContent = label;
    var resets = root.querySelectorAll('[data-aaa-finder-reset]');
    for (var k = 0; k < resets.length; k++) resets[k].hidden = answered === 0;
    if (basis) {
      // r8: nothing is pre-ticked. Before any tap the badge says this is our
      // starting pick; after a tap the line spells out what the pick is for
      // (answered groups as given, the rest marked as assumed).
      var btxt = basis.querySelector('[data-aaa-finder-basis-text]') || basis;
      basis.classList.toggle('is-answered', answered > 0);
      if (answered === 0) {
        btxt.textContent = 'Nothing answered yet. Tap the three questions to make it yours.';
      } else {
        var said = [], assumed = [];
        ['taste', 'effort', 'crowd'].forEach(function (q) {
          var w = WORDS[q][q === 'taste' ? t : q === 'effort' ? e : c];
          (touched[q] ? said : assumed).push(w);
        });
        btxt.textContent = 'For ' + said.join(', ') + (assumed.length ? ' (assuming ' + assumed.join(', ') + ' until you answer)' : '') + '.';
      }
    }
    if (card && window.__aaaFit) window.__aaaFit(card);
    if (card && fromUser) {
      card.classList.remove('is-in'); void card.offsetWidth; card.classList.add('is-in');
      // Phones: the result sits straight under question 3. After the last
      // question (or once all three are answered) bring the pick into view.
      if (window.matchMedia('(max-width: 899px)').matches && (fromUser === 'crowd' || answered === 3)) {
        var r = card.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.55 || r.top < 0) {
          var reduceM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var out = root.querySelector('.aaa-finder__out') || card;
          window.scrollTo({ top: window.pageYOffset + out.getBoundingClientRect().top - 12, behavior: reduceM ? 'auto' : 'smooth' });
        }
      }
    }
  }
  form.addEventListener('change', function (ev) {
    if (ev.target && ev.target.name) touched[ev.target.name] = true;
    update(ev.target && ev.target.name ? ev.target.name : true);
  });
  // "How we match you" fills the left column on desktop; on phones it
  // starts closed so the result follows the questions directly.
  // r8: closed everywhere (markup has no "open"); the summary opens it.
  root.addEventListener('click', function (ev) {
    var r = ev.target.closest('[data-aaa-finder-reset]');
    if (!r) return;
    form.reset();
    touched = {};
    update(false);
    var first = form.querySelector('input');
    if (first) first.focus();
  });
  update(false);
  // Hero CTA: jump to the finder and put focus on the first question.
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-aaa-finder-open]');
    if (!a) return;
    ev.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var first = form.querySelector('input');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    root.classList.remove('is-flash'); void root.offsetWidth; root.classList.add('is-flash');
  });
})();

/* Cut-out scale normaliser (.aaa-fit). Supplier pack shots are framed any
   old way: one cooker fills its file, the next floats in white space. Each
   cut-out is sampled once on a 64px canvas (the CDN serves CORS headers and
   the img carries crossorigin), the product's bounding box is found against
   the near-white background, and the image is scaled + re-centred with the
   CSS `scale` / `translate` properties so every product fills the same box.
   Photos (no white corners) are left alone. Layout never moves: only the
   paint transform changes, and images fade in once fitted. */
(function () {
  'use strict';
  var imgs = document.querySelectorAll('img.aaa-fit');
  if (!imgs.length || !window.HTMLCanvasElement) return;
  var TARGET = 0.86, MIN = 0.8, MAX = 1.45, N = 64;
  var cv = document.createElement('canvas');
  var cx = cv.getContext && cv.getContext('2d', { willReadFrequently: true });
  if (!cx) return;
  document.documentElement.classList.add('aaa-fit-on');
  function done(img) { img.classList.add('is-fit'); }
  function fit(img) {
    try {
      var W = img.naturalWidth, H = img.naturalHeight;
      if (!W || !H) return done(img);
      var w = W >= H ? N : Math.round(N * W / H), h = W >= H ? Math.round(N * H / W) : N;
      cv.width = w; cv.height = h;
      cx.clearRect(0, 0, w, h);
      cx.drawImage(img, 0, 0, w, h);
      var d = cx.getImageData(0, 0, w, h).data;
      function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
      var corners = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1)];
      var bg = [0, 0, 0];
      for (var c = 0; c < 4; c++) {
        var k = corners[c];
        if (k[3] > 20 && (k[0] < 200 || k[1] < 200 || k[2] < 200)) return done(img); // a photo, not a pack shot
        for (var q = 0; q < 3; q++) bg[q] += (k[3] > 20 ? k[q] : 255) / 4;
      }
      // Finder tiles (data-aaa-bg): paint the tile with the shot's own studio
      // colour, so the pack shot reads edge to edge, not as a box in a box.
      var T = TARGET;
      if (img.hasAttribute('data-aaa-bg') && img.parentNode) {
        img.parentNode.style.backgroundColor = 'rgb(' + Math.round(bg[0]) + ',' + Math.round(bg[1]) + ',' + Math.round(bg[2]) + ')';
        T = 0.92;
      }
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        if (d[i + 3] < 20) continue;
        if (Math.abs(d[i] - bg[0]) > 22 || Math.abs(d[i + 1] - bg[1]) > 22 || Math.abs(d[i + 2] - bg[2]) > 22) {
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
      }
      if (x1 < 0) return done(img);
      var bw = (x1 - x0 + 1) / w, bh = (y1 - y0 + 1) / h;
      // Rendered image box inside the element (object-fit: contain).
      var Ew = img.clientWidth, Eh = img.clientHeight;
      if (!Ew || !Eh) return done(img); // hidden (e.g. a finder card): refit when shown
      var s0 = Math.min(Ew / w, Eh / h), rw = w * s0, rh = h * s0;
      var f = Math.min(T * Ew / (bw * rw), T * Eh / (bh * rh));
      f = Math.max(MIN, Math.min(MAX, f));
      var ccx = ((x0 + x1 + 1) / 2 / w - 0.5) * rw, ccy = ((y0 + y1 + 1) / 2 / h - 0.5) * rh;
      img.style.scale = f.toFixed(3);
      img.style.translate = (-ccx * f / Ew * 100).toFixed(2) + '% ' + (-ccy * f / Eh * 100).toFixed(2) + '%';
      img.setAttribute('data-fitted', '');
    } catch (e) { /* tainted canvas or decode error: leave as shot */ }
    done(img);
  }
  window.__aaaFit = function (scope) {
    var list = (scope || document).querySelectorAll('img.aaa-fit:not([data-fitted])');
    for (var j = 0; j < list.length; j++) if (list[j].complete && list[j].naturalWidth) fit(list[j]);
  };
  for (var i = 0; i < imgs.length; i++) {
    (function (img) {
      if (img.complete && img.naturalWidth) fit(img);
      else {
        img.addEventListener('load', function () { fit(img); }, { once: true });
        img.addEventListener('error', function () { done(img); }, { once: true });
      }
    })(imgs[i]);
  }
  // Never leave anything hidden.
  setTimeout(function () { for (var j = 0; j < imgs.length; j++) done(imgs[j]); }, 6000);
})();

/* Scroll cue for horizontal tracks ([data-aaa-scroller]): a thin progress
   bar plus "3 / 8" under any track that actually overflows (phones, mostly).
   The thumb is sized once per resize and moved with transform only. */
(function () {
  'use strict';
  var tracks = document.querySelectorAll('[data-aaa-scroller]');
  if (!tracks.length) return;
  Array.prototype.forEach.call(tracks, function (track) {
    var items = track.children;
    if (items.length < 2) return;
    var cue = document.createElement('div');
    cue.className = 'aaa-scrub';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<span class="aaa-scrub__bar"><i></i></span><span class="aaa-scrub__n aaa-num"></span>';
    track.parentNode.insertBefore(cue, track.nextSibling);
    var thumb = cue.querySelector('i'), num = cue.querySelector('.aaa-scrub__n');
    var ratio = 1;
    function size() {
      var sw = track.scrollWidth, cw = track.clientWidth;
      var on = sw - cw > 4;
      cue.classList.toggle('is-on', on);
      ratio = on ? cw / sw : 1;
      thumb.style.width = (ratio * 100).toFixed(2) + '%';
      paint();
    }
    function paint() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + (p * (1 / ratio - 1) * 100).toFixed(2) + '%)';
      var first = items[0], step = items.length > 1 ? items[1].offsetLeft - first.offsetLeft : first.offsetWidth;
      var idx = step > 0 ? Math.round(track.scrollLeft / step) : 0;
      if (p > 0.98) idx = items.length - Math.max(1, Math.floor(track.clientWidth / step));
      // Show the visible range ("1–2 of 8"), not one index: a phone shows two
      // cards and a peek, so "1 / 8" read as if the rest were hidden.
      var vis = Math.max(1, Math.floor((track.clientWidth + 8) / step));
      var a = Math.min(items.length, idx + 1), b = Math.min(items.length, idx + vis);
      num.textContent = (b > a ? a + '–' + b : a) + ' of ' + items.length;
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', size);
    size();
  });
})();

/* Editorial slot tabs (snippets/aaa-home-editorial.liquid): two panels,
   manual only (no autoplay). Arrow keys move between tabs, per the ARIA
   tabs pattern. Without JS both panels simply show in sequence. */
(function () {
  'use strict';
  var ed = document.querySelector('[data-aaa-ed]');
  if (!ed) return;
  var tabs = ed.querySelectorAll('[role="tab"]');
  if (tabs.length < 2) return;
  ed.classList.add('is-js');
  function pick(i, focus) {
    for (var k = 0; k < tabs.length; k++) {
      var on = k === i;
      tabs[k].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[k].tabIndex = on ? 0 : -1;
      var panel = document.getElementById(tabs[k].getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        if (on) { panel.classList.remove('is-in'); void panel.offsetWidth; panel.classList.add('is-in'); }
      }
    }
    if (focus) tabs[i].focus();
  }
  Array.prototype.forEach.call(tabs, function (t, i) {
    t.addEventListener('click', function () { pick(i, false); });
    t.addEventListener('keydown', function (e) {
      var n = tabs.length, j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault(); pick(j, true);
    });
  });
  pick(0, false);
  ed.querySelector('.aaa-ed__panel').classList.remove('is-in');
})();

/* Below-the-fold images: native loading="lazy" keeps the first paint lean,
   but on a long page a fast flick (or a full-page capture) can outrun it and
   leave empty plates. Once the page has loaded and the main thread is idle,
   the remaining lazy images are promoted to eager in small batches, so
   everything is decoded before anyone scrolls to it. Nothing above the fold
   competes with the hero (it is all after window.load). */
(function () {
  'use strict';
  function promote() {
    var list = Array.prototype.slice.call(document.querySelectorAll('main img[loading="lazy"]'));
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 120); };
    (function batch() {
      var chunk = list.splice(0, 6);
      for (var i = 0; i < chunk.length; i++) chunk[i].loading = 'eager';
      if (list.length) idle(batch, { timeout: 600 });
    })();
  }
  if (document.readyState === 'complete') setTimeout(promote, 300);
  else window.addEventListener('load', function () { setTimeout(promote, 300); }, { once: true });
})();

/* Step-up rail tabs (snippets/aaa-home-rail.liquid, pass 2 r8): "Step-up
   picks" and "On sale now" as one rail with two views, per the ARIA tabs
   pattern (arrow keys, Home / End). Without JS both lists show in turn.
   Any link to #AaaDeals (the hero's "On sale now") opens the sale tab. */
(function () {
  'use strict';
  var list = document.querySelector('[data-aaa-tabs]');
  if (!list) return;
  var rail = list.closest('.aaa-rail');
  var tabs = list.querySelectorAll('[role="tab"]');
  if (!rail || tabs.length < 2) return;
  rail.classList.add('is-tabs');
  var pt = rail.querySelector('[data-aaa-rail-track]');
  var n = list.querySelector('[data-aaa-tab-n]');
  if (pt && n) n.textContent = pt.children.length;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pick(i, focus) {
    for (var k = 0; k < tabs.length; k++) {
      var on = k === i;
      tabs[k].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[k].tabIndex = on ? 0 : -1;
      var panel = document.getElementById(tabs[k].getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        if (on && window.__aaaFit) window.__aaaFit(panel);
      }
    }
    rail.setAttribute('data-tab', i === 0 ? 'picks' : 'deals');
    // Rail arrows and scroll cues measure their track: re-measure now.
    window.dispatchEvent(new Event('resize'));
    if (focus) tabs[i].focus();
  }
  Array.prototype.forEach.call(tabs, function (t, i) {
    t.addEventListener('click', function () { pick(i, false); });
    t.addEventListener('keydown', function (e) {
      var c = tabs.length, j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % c;
      else if (e.key === 'ArrowLeft') j = (i - 1 + c) % c;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = c - 1;
      if (j < 0) return;
      e.preventDefault(); pick(j, true);
    });
  });
  var dealIdx = -1;
  for (var d = 0; d < tabs.length; d++) if (tabs[d].getAttribute('aria-controls') === 'AaaDeals') dealIdx = d;
  pick(location.hash === '#AaaDeals' && dealIdx > -1 ? dealIdx : 0, false);
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#AaaDeals"]');
    if (!a || dealIdx < 0) return;
    ev.preventDefault();
    pick(dealIdx, false);
    rail.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    setTimeout(function () { tabs[dealIdx].focus({ preventScroll: true }); }, reduce ? 0 : 500);
  });
})();
